import { Injectable } from '@angular/core';
import {
  AddOnFeaturesParam,
  BusinessPlansParam,
  CustomizeAssetState
} from '@models/customize-service.model';
import { OrderPriceSummaryItem, ShoppingCartData } from '@models/shopping-cart.model';
import { ADDED_FEATURE, REMOVED_FEATURE, UNCHANGED_FEATURE } from '@models/shopping.model';
import { TranslationService } from '@services/translation/translation.service';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomizeService {
  readonly cartChanges: Subject<ShoppingCartData>;
  readonly state: CustomizeAssetState;
  private cart: ShoppingCartData;

  constructor(private translation_svc: TranslationService) {
    this.cartChanges = new Subject<ShoppingCartData>();
    this.state = {
      plans_param: new Subject<BusinessPlansParam>(),
      features_param: new Subject<AddOnFeaturesParam>(),
      extras: new BehaviorSubject<{ [k: string]: string | number }>({})
    };
  }

  setCart(value: ShoppingCartData) {
    this.cart = { ...value };
    this.cartChanges.next(this.cart);
  }

  getCart(): ShoppingCartData {
    return structuredClone(this.cart);
  }

  setState(
    key: 'plans_param' | 'features_param' | 'extras',
    value: BusinessPlansParam | AddOnFeaturesParam | { [k: string]: string | number | boolean }
  ) {
    this.state[key]?.next(
      value as BusinessPlansParam & AddOnFeaturesParam & { [k: string]: string | number }
    );
  }

  featureType(item: OrderPriceSummaryItem): string {
    switch (item.sub_type) {
      case ADDED_FEATURE:
        return this.translation_svc.translate('added');
      case REMOVED_FEATURE:
        return this.translation_svc.translate('removed');
      case UNCHANGED_FEATURE:
        return this.translation_svc.translate('unchanged');
      default:
        return '';
    }
  }
}
